import {fetchAllPages,postEndPoint,deleteEndPoint} from './wordpress'

export const createComment = async (data) => {
    if( data.id ) delete data.id;

    return await postEndPoint('comments',data)
}

export const saveComment = async (id, data) => {
    return await postEndPoint(`comments/${id}`,data)
}

export const fetchComments = async (afterDate,beforeDate) => {

    const fetchString = `comments?after=${encodeURIComponent(afterDate)}&before=${encodeURIComponent(beforeDate)}`
    const comments = await fetchAllPages(fetchString)

    return comments;
}

export const deleteComment = async (id) => {
    return await deleteEndPoint(`comments/${id}`)
}